import {doDelete, doGet, doPost, doPut} from './http.service'
import {Proposal, ProposalStatus} from "../types/Proposal";
import {Page} from "../types/Page";

export interface ProposalFilter {
    page: number,
    size: number,
    sortKey: string,
    sortOrder: 'asc'|'desc',
    phone?: string
    name?:string
    source?:string
    address?:string
    priceMin?:string
    favorite?:boolean
    priceMax?:string
    pricePerMeterMin?:string
    pricePerMeterMax?:string
    areaMin?:string
    areaMax?:string
    id?:string
    my?:boolean
    polygon?: { lat: number; lng: number }[]
    proposalStatuses: ProposalStatus[]
    
}

export function loadSources() {
    return doGet<string[]>('/proposals/sources')
}
export function loadProposals(filter: ProposalFilter) {
    return doGet<Page<Proposal>>('/public/proposals', {params: filter});
}
export function loadProposal(id:string) {
    return doGet<Proposal>('/public/proposals/' + id);
}
export function findEditId(id:string) {
    return doGet<Proposal>('/public/proposal-by-edit/' + id);
}
export function updateProposal(proposal: Proposal) {
    return doPut<Proposal>('/proposals/' + proposal.id, proposal);
}
export function updateProposalPublic(proposal: Proposal) {
    return doPut<Proposal>('/public/proposal-by-edit/' + proposal.editId, proposal);
}
export function createProposal(proposal: Proposal) {
    return doPost<Proposal>('/public/proposals', proposal);
}
export function updateFavorite(proposalId: string) {
    return doPut<void>('/proposals/' + proposalId + "/favorite");
}
export function deleteProposal(id: string) {
    return doDelete<void>('/proposals/' + id);
}

export function updateProposalStatus(id: string, proposalStatus:ProposalStatus) {
    return doPut<Proposal>('/proposals/' + id + '/proposal-status', {proposalStatus});
}

export function sendToTelegram(id:string) {
    return doPost<void>('/proposals/' + id + '/telegram');
}


export function generatePdfReport(idList:string[]) {
    return doPost<Blob>('/proposals/pdf', idList, {
        responseType: 'blob'
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        // Create a temporary link to trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'document.pdf'); // filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the object URL after download
        window.URL.revokeObjectURL(url);
    });
}
